// =============================================================================
// CARD COMPONENT
// =============================================================================

import React from 'react';
import { cn } from '@/utils';
import type { CardProps } from '@/types';

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  image,
  imageCredit,
  actions,
  children,
  className,
  ...props
}) => {
  return (
    <div className={cn('card', className)} {...props}>
      {image && (
        <div className="card-image">
          <img src={image} alt={title || ''} />
          {imageCredit && (
            <div className="card-image-credit">
              <span dangerouslySetInnerHTML={{ __html: imageCredit }} />
            </div>
          )}
        </div>
      )}
      
      {(title || subtitle) && (
        <div className="card-header">
          {title && <h3>{title}</h3>}
          {subtitle && <p className="text-secondary">{subtitle}</p>}
        </div>
      )}
      
      {children && (
        <div className="card-body">
          {children}
        </div>
      )}
      
      {actions && (
        <div className="card-footer">
          {actions}
        </div>
      )}
    </div>
  );
};
